import React, { FC, useState }         from "react";
import { useDispatch }                 from "react-redux";
import { Button, Header, Icon, Modal } from "semantic-ui-react";
import DeleteCustomerRecord            from "../../../../application/usecase/record/customer/DeleteCustomerRecord";
import Customer                        from "../../../../domain/customer/Customer";
import CustomerRecord                  from "../../../../domain/record/customer/CustomerRecord";

interface Props {
  customer: Customer;
  customerRecord: CustomerRecord;
}

const CustomerRecordDeleteButton: FC<Props> = (props: Props) => {
  const {customer, customerRecord} = props;
  const [open, setOpen] = useState(false);
  const deleteCustomerRecord: DeleteCustomerRecord = new DeleteCustomerRecord(useDispatch());
  return (
    <>
      <Button
        icon
        labelPosition="left"
        negative
        onClick={ () => setOpen(true) }
      >
        <Icon name="trash"/>
        削除する
      </Button>

      <Modal
        open={ open }
      >
        <Modal.Header>記録削除の確認</Modal.Header>

        <Modal.Content>
          <Header
            as="h5"
            icon="info circle"
            dividing
            content={ `${ customer.detail.name.lastName.value } ${ customer.detail.name.firstName.value } の ${ customerRecord.date.asText() } の記録を削除します。` }
            color="red"
          />
          <Modal.Description>
            <p>よろしいですか？</p>
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button
            onClick={ () => setOpen(false) }
          >
            閉じる
          </Button>

          <Button
            icon
            labelPosition="left"
            negative
            onClick={ () => {
              deleteCustomerRecord.execute(customer.id, customerRecord.id);
              setOpen(false);
            } }
          >
            <Icon name="trash"/>
            削除する
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default CustomerRecordDeleteButton;
